export default __webpack_public_path__ + "static/media/bg.ddff2a1e.webp";